//=================================================
//    summary: DCP About 分頁 -- Hook
//
//    remarks: 000 Tim 2021/11/12 Create
//================================================
import React, { useEffect } from 'react'
import cssAbout from './About.module.scss'

// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables


const COMP_NAME = "About"

function About(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])

    // #region Render元件
    /*===========================================
    summary: CorporationMain 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2022/11/23 增加 iOS版號
    ===========================================*/
    function ComponentCorporationMain()
    {   
        let strVersion = window.gAppUI.LBL_Version + ": " + process.env.REACT_APP_LOG_VERSION
        if (
            (typeof (window.gSession.App.AppVersion) !== 'undefined') &&
            (window.gSession.App.AppVersion !== null) &&
            (window.gSession.App.AppVersion !== "")
            )
        {
            strVersion += " ("
            strVersion += window.gSession.App.AppVersion
            strVersion += ")"
        } // end of if (window.gSession.App.AppVersion !== "")
        
        return(
            <div className={cssAbout.divCorporationMain}>
                <div className={cssAbout.divCorporation}>
                    {window.gAppUI.LBL_BCCorporation}
                </div>
                <div className={cssAbout.divCorporation}>
                    {strVersion}
                </div>
            </div>
        )
    } // end of ComponentCorporationMain

    /*===========================================
    summary: About DCP 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentAboutDCPMain()
    {   
        return(
            <div className={cssAbout.divAboutDCPMain}>
                <div className={cssAbout.divAboutText}>
                    {window.gAppUI.LBL_AboutDCP}
                </div>
                <div className={cssAbout.divAboutText}>
                    {window.gAppUI.LBL_AboutDCPMsg}
                </div>
            </div>
        )
    } // end of ComponentAboutDCPMain

    /*===========================================
    summary: About Us 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentAboutUsMain()
    {   
        return(
            <div className={cssAbout.divAboutUsMain}>
                <div className={cssAbout.divAboutText}>
                    {window.gAppUI.LBL_AboutUs}
                </div>
                <div className={cssAbout.divAboutText}>
                    {window.gAppUI.LBL_AboutUsMsg}
                </div>
            </div>
        )
    } // end of ComponentAboutUsMain
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render About 內容 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                <ComponentAboutUsMain />
                
                <ComponentAboutDCPMain />

                <ComponentCorporationMain />
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                {RenderContentWrapper()}
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default About